import {API} from '../../networking/http'
import {BookingForm, EntityType, FormQuestion} from './types'

// Fetch the form assigned to an entity
export const getFormForEntityEndpoint = (entityType: EntityType, entityId: string) =>
  `forms/allocation?entityType=${entityType}&entityId=${entityId}`

type RawFormResponse = {
  id?: string
  formId?: string
  title?: string
  description?: string
  questions?: FormQuestion[]
}

export const fetchFormForEntity = async (entityType: EntityType, entityId: string): Promise<BookingForm | null> => {
  try {
    const res = await API.get<unknown, {form?: RawFormResponse}>(getFormForEntityEndpoint(entityType, entityId))
    const formResponse = res.data.form
    if (!formResponse) {
      return null
    }
    return {
      formId: formResponse.id || formResponse.formId || '',
      title: formResponse.title || '',
      description: formResponse.description || '',
      questions: formResponse.questions || []
    }
  } catch {
    // No form assigned or API error — return null silently
    return null
  }
}

export const uploadFormAttachment = async (fileBase64: string, venueId?: string): Promise<string> => {
  const res = await API.post<unknown, {url: string}>('forms/upload-attachment', {
    file: fileBase64,
    venueId
  })
  return res.data.url
}
